import { ExternalLink } from "lucide-react";

function signalClass(isSharpFade, isPublicAlign) {
  if (isSharpFade) return "border-[#00D4FF] text-[#00D4FF]";
  if (isPublicAlign) return "border-amber-400 text-amber-400";
  return "border-zinc-600 text-zinc-400";
}

export function PlayHero({ card, hero, sportLabel, signal, Stars, confidence }) {
  const isSharpFade = signal.includes("SHARP");
  const isPublicAlign = signal.includes("PUBLIC");
  return (
    <div
      className="relative h-32 border-b border-zinc-800 overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(9,9,11,0.4), rgba(9,9,11,0.92)), url(${hero})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 p-5 flex flex-col justify-between">
        <div className="flex items-center justify-between">
          <span className="overline text-[#00D4FF]">{sportLabel}</span>
          <div className="flex items-center gap-2">
            {signal && (
              <span
                data-testid={`sharp-signal-${card.game_id}`}
                className={`mono text-[10px] px-2 py-0.5 tracking-widest border ${signalClass(
                  isSharpFade,
                  isPublicAlign
                )}`}
              >
                {signal}
              </span>
            )}
            <Stars n={confidence} />
          </div>
        </div>
        <div>
          <div className="font-display text-xl leading-tight">
            {card.away?.name || "Away"}{" "}
            <span className="text-zinc-500">@</span> {card.home?.name || "Home"}
          </div>
        </div>
      </div>
    </div>
  );
}

export function KeyFactorsGrid({ kf }) {
  const items = [
    { label: "KEY PLAYER", val: kf.starter_or_key_player },
    { label: "INJURIES", val: kf.injuries_to_monitor },
    { label: "WEATHER/VENUE", val: kf.weather_or_venue },
    { label: "PUBLIC", val: kf.public_betting_trend },
  ];
  return (
    <dl className="grid grid-cols-2 gap-3 text-xs">
      {items.map((i) => (
        <div key={i.label} className="border border-zinc-800 p-3">
          <dt className="overline mb-1">{i.label}</dt>
          <dd className="mono text-zinc-200">{i.val || "—"}</dd>
        </div>
      ))}
    </dl>
  );
}

export function MartingalePlanBlock({ mp }) {
  return (
    <div className="border border-[#00D4FF]/30 bg-[#00D4FF]/5 p-4">
      <div className="flex items-center justify-between mb-2">
        <span className="overline neon-text">MARTINGALE PLAN</span>
        <span className="mono text-xs text-zinc-400">
          {mp.max_steps_suggested || 4} steps ·{" "}
          {mp.recommended_base_stake_pct_of_bankroll || 1}% base
        </span>
      </div>
      <p className="text-xs text-zinc-300 leading-relaxed">{mp.reasoning || "—"}</p>
    </div>
  );
}

export function DkMoneylineRow({ dkMoneyline }) {
  if (!dkMoneyline || dkMoneyline.length === 0) return null;
  return (
    <div className="border border-zinc-800 bg-zinc-950 p-3 text-xs">
      <div className="overline mb-2">DRAFTKINGS · LIVE</div>
      <div className="flex gap-3 mono text-zinc-300">
        {dkMoneyline.map((o) => (
          <span key={o.name}>
            {o.name}{" "}
            <span className="neon-text">
              {o.price > 0 ? `+${o.price}` : o.price}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}

export function DkCtaButton({ url, gameId }) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`dk-cta-${gameId}`}
      className="flex items-center justify-center gap-2 py-3 bg-[#53d337] hover:bg-[#00D4FF] text-black font-mono uppercase tracking-widest text-xs transition-colors"
    >
      Place on DraftKings <ExternalLink size={12} strokeWidth={2} />
    </a>
  );
}
